import API from './axios';

export const notificationService = {
  // Send single notification
  sendNotification: async (notificationData) => {
    try {
      console.log('🔍 [SERVICE] sendNotification called with:', notificationData);
      const response = await API.post('/admin/notifications/send', notificationData);
      console.log('🔍 [SERVICE] sendNotification response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] sendNotification error:', error);
      throw error.response?.data || error;
    }
  },

  // Send bulk notifications
  sendBulkNotifications: async (bulkData) => {
    try {
      console.log('🔍 [SERVICE] sendBulkNotifications called with:', bulkData);
      const response = await API.post('/admin/notifications/bulk', bulkData);
      console.log('🔍 [SERVICE] sendBulkNotifications response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] sendBulkNotifications error:', error);
      throw error.response?.data || error;
    }
  },

  // Get notification history
  getNotificationHistory: async (filters = {}) => {
    try {
      // console.log('🔍 [SERVICE] getNotificationHistory called with filters:', filters);
      
      // const params = new URLSearchParams();
      // Object.keys(filters).forEach(key => {
      //   if (filters[key]) {
      //     params.append(key, filters[key]);
      //   }
      // });
      // ?${params.toString()}
      // alert("getNotificationHistory");
      const url = `/admin/notifications/history`;
      console.log('🔍 [SERVICE] Making GET request to:', url);
      
      const response = await API.get(url);
      console.log('🔍 [SERVICE] getNotificationHistory response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] getNotificationHistory error:', error);
      console.error('❌ [SERVICE] Error response:', error.response);
      throw error.response?.data || error;
    }
  },

  // Get notification statistics
  getNotificationStats: async (period = 'week') => {
    try {
      console.log('🔍 [SERVICE] getNotificationStats called with period:', period);
      const url = `/admin/notifications/stats?period=${period}`;
      console.log('🔍 [SERVICE] Making GET request to:', url);
      
      const response = await API.get(url);
      console.log('🔍 [SERVICE] getNotificationStats response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] getNotificationStats error:', error);
      console.error('❌ [SERVICE] Error response:', error.response);
      throw error.response?.data || error;
    }
  },

  // Get notification by ID
  getNotificationById: async (notificationId) => {
    try {
      console.log('🔍 [SERVICE] getNotificationById called with ID:', notificationId);
      const response = await API.get(`/admin/notifications/${notificationId}`);
      console.log('🔍 [SERVICE] getNotificationById response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] getNotificationById error:', error);
      throw error.response?.data || error;
    }
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    try {
      console.log('🔍 [SERVICE] deleteNotification called with ID:', notificationId);
      const response = await API.delete(`/admin/notifications/${notificationId}`);
      console.log('🔍 [SERVICE] deleteNotification response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] deleteNotification error:', error);
      throw error.response?.data || error;
    }
  }
};

export default notificationService;
